import { Dispatch, Action as ReduxAction, Store } from 'redux';
import { Action, State } from 'redux/types';
import { asArray } from 'utils/collections';
import { getCurrentPreview } from './bridge';
import { EmbedPreviewSyncOptions } from './types';
import { isTriggerAction } from './utils';

export default function createEmbedPreviewSync(
  options: EmbedPreviewSyncOptions,
) {
  const { triggerAction, debounceMillis = 300 } = options;
  const actionFilters = asArray(triggerAction);

  return (store: Store<State, Action<string>>) => {
    const { getState } = store;
    let timeoutId: number | null = null;

    const flush = () => {
      timeoutId = null;
      const registration = getCurrentPreview();

      if (!registration) {
        return;
      }

      const message = registration.buildMessage(getState);

      if (message) {
        registration.send(message);
      }
    };

    return (next: Dispatch) => (action: ReduxAction) => {
      if (isTriggerAction(action, actionFilters)) {
        if (timeoutId !== null) {
          window.clearTimeout(timeoutId);
        }

        timeoutId = window.setTimeout(flush, debounceMillis);
      }

      return next(action);
    };
  };
}
